import type { TestCaseType } from '../types';
import { ALL_CASE_TYPES, CASE_TYPE_LABELS } from '../types';

interface CaseTypeSelectProps {
    value: TestCaseType;
    onChange: (v: TestCaseType) => void;
    disabled?: boolean;
    className?: string;
}

export function CaseTypeSelect({ value, onChange, disabled, className = '' }: CaseTypeSelectProps) {
    return (
        <select
            data-testid="case-type-select"
            aria-label="Case type"
            value={value}
            onChange={(e) => onChange(e.target.value as TestCaseType)}
            disabled={disabled}
            className={`text-sm border border-slate-200 dark:border-gh-border-dark rounded-lg px-2 py-1.5
                bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-100
                focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${className}`}
        >
            {ALL_CASE_TYPES.map((t) => (
                <option key={t} value={t}>{CASE_TYPE_LABELS[t]}</option>
            ))}
        </select>
    );
}
